export interface EdiOrderTableMenuRow {
	id: number;
	isLocation: boolean;
	name: string;
	sendASNsViaEDI: boolean;
}

export class EdiOrderTableMenuRow implements EdiOrderTableMenuRow {	
	constructor(data?: Partial<EdiOrderTableMenuRow>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}